import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractModal } from 'src/app/common/modal/abstract-modal';

@Component({
  selector: 'app-check-remove-user-modal',
  templateUrl: './check-remove-user-modal.component.html',
  styleUrls: ['./check-remove-user-modal.component.css']
})
export class CheckRemoveUserModalComponent extends AbstractModal {
  @Output()
  remove = new EventEmitter<any>();

  onRemove() {
    this.remove.emit();
  }
}
